
import React, { useState, useEffect } from "react";
import "./Style.scss";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "./Components/Header/Header";
import { FORM_CONFIG } from "./Shared/Constant/MasterFormConstants";
import Footer from "./Components/Footer/Footer";
import { Navigate, useRoutes } from "react-router-dom";
import DashboardView from "./Layout/Dashboard/DashboardView";
import MastersView from "./Layout/Master/MastersView";
import SideBar from "./Components/SideBar/SideBar";
import MasterTableView from "./Layout/Master/MasterTableView/MasterTableView";
import { MASTER_VIEW_CONFIG } from "./Shared/Constant/MasterViewConstants";
import MasterTypes from "./Shared/Constant/MastersTypes";
import ProfileSetting from "./Layout/Profile/ProfileSetting";
import IECModuleView from "./Layout/IECModule/IECModuleView";
import Changelanguage from "./Layout/ChangeLanguage/Changelanguage";
import { LanguageProvider } from "./Layout/ChangeLanguage/LanguageProvider";
import axiosInstance from "./Shared/Utils/axiosInstance"; // Import your axiosInstance with interceptors
import RefreshTokenPopup from "./Components/RefreshTokenPopup";
import ANMDetailsView from "./Layout/ANMDetails/ANMDetailsView";
import AFDetailsView from "./Layout/AFDetails/AFDetailsView";
import Loader from "./LoaderContext";

export const routes = [
  {
    path: "dashboard",
    headerName: "Dashboard / डॅशबोर्ड",
    element: <DashboardView />,
  },
  {
    path: "changelanguage",
    headerName: "Change Language / भाषा बदला",
    element: <Changelanguage />,
  },
  {
    path: "profilesettings",
    headerName: "Profile Setting / प्रोफाइल सेटिंग",
    element: <ProfileSetting />,
  },
  {
    path: "anmdetails",
    headerName: "ANM Details / एएनएम तपशील",
    element: <ANMDetailsView />,
  },
  {
    path: "afdetails",
    headerName: "AF Details / एफ तपशील",
    element: <AFDetailsView />,
  },
  {
    path: "iecmodule",
    headerName: "IEC Module / आयईसी मॉड्यूल",
    element: <IECModuleView />,
  },
  {
    path: "master",
    children: [
      {
        path: "",
        headerName: "All Masters / सगळे मास्टर्स",
        element: <MastersView />,
      },
      {
        path: MasterTypes.DISTRICT,
        headerName: "District Master / जिल्हा मास्तर",
        element: (
          <MasterTableView
            masterType={MasterTypes.DISTRICT}
            formConfig={FORM_CONFIG.districtFields}
            viewConfig={MASTER_VIEW_CONFIG.districtMaster}
          />
        ),
      },
      // MasterTableView
      {
        path: MasterTypes.TALUKA,
        headerName: "Taluka Master / तालुका मास्तर",
        element: (
          <MasterTableView
            masterType={MasterTypes.TALUKA}
            formConfig={FORM_CONFIG.talukaFields}
            viewConfig={MASTER_VIEW_CONFIG.talukaMaster}
          />
        ),
        // element: <TalukaTableView />,
      },
      {
        path: MasterTypes.AREATYPE,
        headerName: "Area Type Master / क्षेत्र प्रकार मास्टर",
        element: (
          <MasterTableView
            masterType={MasterTypes.AREATYPE}
            formConfig={FORM_CONFIG.areaFields}
            viewConfig={MASTER_VIEW_CONFIG.areaTypeMaster}
          />
        ),
      },
      {
        path: MasterTypes.PHC,
        headerName: "PHC Master / पीएचसी मास्टर",
        element: (
          <MasterTableView
            masterType={MasterTypes.PHC}
            formConfig={FORM_CONFIG.phcFields}
            viewConfig={MASTER_VIEW_CONFIG.phcMaster}
          />
        ),
      },
      {
        path: MasterTypes.UPHC,
        headerName: "URBAN PHC Master / शहरी पीएचसी मास्टर",
        element: (
          <MasterTableView
            masterType={MasterTypes.UPHC}
            formConfig={FORM_CONFIG.uphcFields}
            viewConfig={MASTER_VIEW_CONFIG.uphcMaster}
          />
        ),
      },
      {
        path: MasterTypes.SUBCENTER,
        headerName: "Subcenter Master / उपकेंद्र मास्तर",
        element: (
          <MasterTableView
            masterType={MasterTypes.SUBCENTER}
            formConfig={FORM_CONFIG.subcenterFields}
            viewConfig={MASTER_VIEW_CONFIG.subcenterMaster}
          />
        ),
      },
      {
        path: MasterTypes.VILLAGE,
        headerName: "Village Master / गांवचे मास्तर",
        element: (
          <MasterTableView
            masterType={MasterTypes.VILLAGE}
            formConfig={FORM_CONFIG.villageFields}
            viewConfig={MASTER_VIEW_CONFIG.villageMaster}
          />
        ),
      },
      {
        path: MasterTypes.SUBAREA,
        headerName: "Sub Area Master / उपक्षेत्र मास्तर",
        element: (
          <MasterTableView
            masterType={MasterTypes.SUBAREA}
            formConfig={FORM_CONFIG.subareaFields}
            viewConfig={MASTER_VIEW_CONFIG.subareaMaster}
          />
        ),
      },
      {
        path: MasterTypes.GOVERNINGBODY,
        headerName: "Governing Body Master / गव्हर्निंग बॉडी मास्टर",
        element: (
          <MasterTableView
            masterType={MasterTypes.GOVERNINGBODY}
            formConfig={FORM_CONFIG.governingbodyFields}
            viewConfig={MASTER_VIEW_CONFIG.localgoverningbodymaster}
          />
        ),
        // element: <TalukaTableView />,
      },
      
      {
        path: MasterTypes.CORPORATION,
        headerName: "Corporation Council Master / कॉर्पोरेशन कौन्सिल मास्टर",
        element: (
          <MasterTableView
            masterType={MasterTypes.CORPORATION}
            formConfig={FORM_CONFIG.corporationFields}
            viewConfig={MASTER_VIEW_CONFIG.corporation_coucil_master}
          />
        ),
        // element: <TalukaTableView />,
      },
      {
        path: MasterTypes.BANK,
        headerName: "Bank Master / बँक मास्टर",
        element: (
          <MasterTableView
            masterType={MasterTypes.BANK}
            viewConfig={MASTER_VIEW_CONFIG.bankMaster}
            formConfig={FORM_CONFIG.bankFields}
          />
        ),
      },
      {
        path: MasterTypes.BANK_BRANCH,
        headerName: "Bank Branch Master / बँक शाखा मास्तर",
        element: (
          <MasterTableView
            masterType={MasterTypes.BANK_BRANCH}
            viewConfig={MASTER_VIEW_CONFIG.bankBranchMaster}
            formConfig={FORM_CONFIG.bankFields}
          />
        ),
      },
      {
        path: MasterTypes.ROLE,
        headerName: "Role Master / भूमिका मास्टर",
        element: (
          <MasterTableView
            masterType={MasterTypes.ROLE}
            formConfig={FORM_CONFIG.roleFields}
            viewConfig={MASTER_VIEW_CONFIG.roleMaster}
          />
        ),
      },
      {
        path: MasterTypes.USER,
        headerName: "User Master / वापरकर्ता मास्टर",
        element: (
          <MasterTableView
            masterType={MasterTypes.USER}
            formConfig={FORM_CONFIG.userFields}
            viewConfig={MASTER_VIEW_CONFIG.userMaster}
          />
        ),
      },
      {
        path: MasterTypes.TRAINING,
        headerName: "Training Master / प्रशिक्षण मास्टर",
        element: (
          <MasterTableView
            masterType={MasterTypes.TRAINING}
            formConfig={FORM_CONFIG.trainingFields}
            viewConfig={MASTER_VIEW_CONFIG.trainingMaster}
          />
        ),
      },
      {
        path: MasterTypes.FACULTY,
        headerName: "Faculty Master / फॅकल्टी मास्टर",
        element: (
          <MasterTableView
            masterType={MasterTypes.FACULTY}
            formConfig={FORM_CONFIG.facultyFields}
            viewConfig={MASTER_VIEW_CONFIG.facultyMaster}
          />
        ),
      },
      {
        path: MasterTypes.TRAINING_CALENDAR,
        headerName: "Training Calendar Master / प्रशिक्षण दिनदर्शिका मास्टर",
        element: (
          <MasterTableView
            masterType={MasterTypes.TRAINING_CALENDAR}
            formConfig={FORM_CONFIG.trainingCalendarFields}
            viewConfig={MASTER_VIEW_CONFIG.trainingCalendarMaster}
          />
        ),
      },
      {
        path: MasterTypes.PROGRAM,
        headerName: "Program Master / कार्यक्रम मास्टर",
        element: (
          <MasterTableView
            masterType={MasterTypes.PROGRAM}
            formConfig={FORM_CONFIG.programFields}
            viewConfig={MASTER_VIEW_CONFIG.programMaster}
          />
        ),
      },
      {
        path: MasterTypes.SCHEME,
        headerName: "Scheme Master / स्कीम मास्टर",
        element: (
          <MasterTableView
            masterType={MasterTypes.SCHEME}
            formConfig={FORM_CONFIG.schemeFields}
            viewConfig={MASTER_VIEW_CONFIG.schemeMaster}
          />
        ),
      },
      {
        path: MasterTypes.ACTIVITY,
        headerName: "Activity Master / क्रियाकलाप मास्टर",
        element: (
          <MasterTableView
            masterType={MasterTypes.ACTIVITY}
            formConfig={FORM_CONFIG.activityFields}
            viewConfig={MASTER_VIEW_CONFIG.activityMaster}
          />
        ),
      },
    ],
  },
  { path: "*", element: <Navigate to="/404" replace /> },
];
const AppRoutes = React.memo(() => {
  return useRoutes(routes);
});
const App = () => {
  const [currentElementWidth, setCurrentElementWidth] = useState("100%");
  const [currElMargin, setCurrElMargin] = useState("220px");
  const token = sessionStorage.getItem("userToken");
  const [isLoading, setIsLoading] = useState(false); 
  const [visible, setVisible] = useState(false);
  const menus = sessionStorage.getItem("accessMenus");
  const handleDialogVisibility = (isVisible) => {
    setVisible(isVisible);
  };
  useEffect(() => {
    document.body.style.overflow = "hidden"; // Prevent page scroll
    const handleResize = () => {
      if (window.innerWidth > 768) {
        const availableWidth = document.body.offsetWidth - 220;
        setCurrentElementWidth(`${availableWidth}px`);
        setCurrElMargin("220px");
      } else {
        setCurrentElementWidth("100%");
        setCurrElMargin(0);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      document.body.style.overflow = "auto"; // Allow scrolling again on cleanup
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    const interceptor = axiosInstance.interceptors.response.use(
      function (response) {
        return response;
      },
      async function (error) {
        const originalRequest = error.config;

        if (
          error &&
          error.response &&
          error.response.status === 401 &&
          !originalRequest._retry
        ) {
          originalRequest._retry = true;
          setVisible(true);
        }

        return Promise.reject(error);
      }
    );
    return () => {
      axiosInstance.interceptors.response.eject(interceptor);
    };
  }, []);
  useEffect(() => {
    const requestInterceptor = axiosInstance.interceptors.request.use((config) => {
      setIsLoading(true); 
      return config;
    });

    const responseInterceptor = axiosInstance.interceptors.response.use(
      (response) => {
        setIsLoading(false); 
        return response;
      },
      (error) => {
        setIsLoading(false); 
        return Promise.reject(error);
      }
    );

    return () => {
      axiosInstance.interceptors.request.eject(requestInterceptor);
      axiosInstance.interceptors.response.eject(responseInterceptor);
    };
  }, []);

  return (
    <div className="App">
      <Loader isVisible={isLoading} />
      <RefreshTokenPopup visible={visible} onHide={handleDialogVisibility} />
      {token != null ? (
        <div>
          <LanguageProvider>
            <div className="grid">
              <div className="md:col-fixed" style={{ width: currElMargin }}>
                <SideBar menus={JSON.parse(menus)}/>
              </div>
              <div
                className="layout-wrapper-div"
                style={{
                  width: currentElementWidth,
                  marginLeft: currElMargin,
                  height: "100vh", // Full height of the viewport
                  overflowY: "auto", // Scroll only on this content area
                }}
              >
                <Header />
                <AppRoutes />
                <Footer footNotes={"NHM Cockpit"} />
              </div>
            </div>
            <ToastContainer
              position="top-center"
              autoClose={1500}
              hideProgressBar={true}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />
          </LanguageProvider>
        </div>
      ) : (
        <Navigate to="/login" />
      )}
    </div>
  );
};

export default App;
